import styled, {css} from "styled-components"

import BrandAvatar from "@irati/ui/src/BrandAvatar"

const DealAvatar = styled(BrandAvatar)`
  width: 140px;
  height: 140px;

  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
    width: 60px;
    height: 60px;
    `}
  `}
`

export default DealAvatar
